/** Standard currency / amount display — always 2 decimal places. */
export function formatAmount(
  value: number | string | null | undefined,
  decimals = 2,
): string {
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return (0).toFixed(decimals);
  }
  return n.toFixed(decimals);
}

/** Nu. prefix with 2 decimal places (e.g. "Nu. 12.34"). */
export function formatNu(
  value: number | string | null | undefined,
  decimals = 2,
): string {
  return `Nu. ${formatAmount(value, decimals)}`;
}
